<template>
    <div :class="[currentTab=='ConfigPage'?'bg-color bg-white':'bg-white']">
        <template v-if="isPageAllowed">
            <div class="tab-bar relative" v-if="currentTab!='ConfigPage'&&!isInfoPage">
                <el-tabs value="batch">
                    <!--<el-tab-pane label="广告管理" name="ad" disabled></el-tab-pane>-->
                    <el-tab-pane label="批量创建" name="batch"></el-tab-pane>
                </el-tabs>
            </div>
            <keep-alive include="ListPage">
                <component :ref="currentTab" :is="currentTab" @changePage="changePage" @update="updateList" :page-func-names="pageFuncNames" :page-dimension-names="pageDimensionNames" @infoPage="changeInfoPage"/>
            </keep-alive>
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面展示vivo媒体相关数据内容与广告管理。</p>
            </NoPermissionInfo>
        </template>
    </div>

</template>

<script>
    import HomeAPI from '@/api/home.js';
    import ListPage from './page/listPage';
    import InfoPage from './page/infoPage';
    import ConfigPage from './page/configPage';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import {undistributeMixin} from '../../mixins/undistributeMixin';

    export default {
        name: "batchCreate",
        mixins: [undistributeMixin],
        components:{
            ListPage,
            InfoPage,
            ConfigPage,
            NoPermissionInfo,
        },
        data(){
            return {
                currentTab:'ListPage',
                isInfoPage:false,
                isPageAllowed:true,
                dimensionList:[],
                pageFunc:[],
            }
        },
        computed:{
            pageFuncNames() {
                return this.pageFunc.map(item => item.name);
            },
            pageDimensionNames(){
                return this.dimensionList.map(item => item.name);
            },
        },
        created() {
            this.getPageAllowAction();
        },
        beforeRouteLeave(to, from, next) {
            if(this.currentTab == 'ListPage') {
                next();
            }else{
                const answer = window.confirm('确定要离开吗？系统可能不会保存您所做的更改!')
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        },
        methods:{
            changeInfoPage(val){
                this.isInfoPage = val||false;
            },
            getPageAllowAction() {
                let navId = this.$route.meta.pid;
                let navTabId = this.$route.meta.id;
                if (navId) {
                    HomeAPI.getPageAllowAction({
                        action_id: navId,
                    }).then(res=>{
                        this.isPageAllowed = true;

                        let resData = res.data || {};
                        let actionData = (resData.page_action || []).find(item => item.id == navTabId);
                        this.dimensionList = this._formatDataConfig(actionData.dimension);
                        this.pageFunc = actionData.func || [];
                    },err=>{
                        console.log('getPageAllowAction error', err);

                        this.isPageAllowed = false;
                        this.dimensionList = [];
                        this.pageFunc = [];
                    })
                }else{
                    this.isPageAllowed = false;
                    this.dimensionList = [];
                    this.pageFunc = [];
                }
            },
            changePage(page){
                switch (page) {
                    case 'config':
                    case 'configPage':
                        this.currentTab = 'ConfigPage';
                        break;
                    case 'list':
                    case 'listPage':
                        this.currentTab = 'ListPage';
                        this.$nextTick(()=>{
                            let listComp = this.$refs.ListPage;
                            if(listComp){
                                listComp.handleGoback();
                            }
                        })
                        break;
                    case 'info':
                    case 'infoPage':
                        this.currentTab = 'InfoPage';
                        break;
                    default:
                        this.currentTab = 'ListPage';
                }
            },
            updateList(){
                this.$nextTick(()=>{
                    let listComp = this.$refs.ListPage;
                    if(listComp){
                        listComp.renovate();
                    }
                })
            },
            _formatDataConfig(list) {
                let copyList = JSON.parse(JSON.stringify(list));
                return (copyList || []).map(item => {
                    let configStr = item.config || "{}";
                    item.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            let configStr = child.config || "{}";
                            child.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                            return child;
                        })
                    }
                    return item;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bg-color{
        background-color: #efefef;
    }
</style>
